import React, { useContext } from 'react';
import {Container, Row, Col, NavLink} from 'react-bootstrap'
import { GlobalContext } from "../../../handlers/GlobalContext";

const FooterThree = ({position}) => {
    const [ state, dispatch] = useContext(GlobalContext);
    const translate = (term, alt) => {
        return state.locale.translation[term] || alt || term;
    }

    return (
        <div className={`footer-section section position-${position} pt-30 pb-30`}>
            <Container fluid>
                <Row className={'align-items-center'}>
                    <Col className={'footer-copyright text-center'}>
                        <p>&copy; {new Date().getFullYear()} EAHP. {translate("sidebar-footer-allRightReserved","all rights reserved").toUpperCase()}. {translate("sidebar-footer-developedBy","developed by").toUpperCase()} <a href="http://www.v-cosmas.com" target="_blank" style={{textDecorationLine: 'underline'}}>V-COSMAS.AI</a></p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default FooterThree;
